// extracted by mini-css-extract-plugin
module.exports = {"container":"_3oItIbK3unGgv3nvTPhMeu","cancelBtn":"_3l88AHvPDQN1xcOcEr9MnT","icon":"_2hmOavzgXoPC7M7ike5G_i","saveBtn":"_35WeAcuJh4UfW0u_hyDkny"};